import React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundColor: theme.palette.background.paper,
    backgroundColor: "black",
    //width: 500,
    primary: "blue",
  },
}));

// const Tabbar = ({ round0, round1, round2TD, round3, exceptionTab }) => {
const Tabbar = ({ round0, round2TD, round3, exceptionTab }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Round Zero" {...a11yProps(0)} />
          {/* <Tab label="Round One" {...a11yProps(1)} /> */}
          <Tab label="Round Two(Tech/Design)" {...a11yProps(2)} />
          <Tab label="Round Three" {...a11yProps(3)} />
          <Tab label="Exception" {...a11yProps(4)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          {round0()}
        </TabPanel>
        {/* <TabPanel value={value} index={1} dir={theme.direction}>
          {round1()}
        </TabPanel> */}
        <TabPanel value={value} index={1} dir={theme.direction}>
          {round2TD()}
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          {round3()}
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          {exceptionTab()}
        </TabPanel>
      </SwipeableViews>
    </div>
  );
};

export default Tabbar;
